import { ReactNode } from 'react';
import { useMultiStyleConfig } from '@chakra-ui/react';
import Box, { BoxProps } from '../Box/Box';
import Icon, { TypeIconName } from '../Icon/Icon';
import Text from '../Text/Text';

export interface EmptyStateProps extends BoxProps {
  description?: ReactNode;
  iconName?: TypeIconName;
  maxContentWidth?: string;
  title: string;
}

const EmptyState = ({ children, description, iconName, maxContentWidth, title, ...rest }: EmptyStateProps) => {
  const css = useMultiStyleConfig('EmptyState', { maxContentWidth });

  return (
    <Box __css={css.box} {...rest}>
      {iconName && <Icon aria-label={title} name={iconName} size="32" />}
      <Text as="h4" textStyle="heading/h4" sx={css.title}>
        {title}
      </Text>
      {description && (
        <Text textStyle="body/md/regular" sx={css.description}>
          {description}
        </Text>
      )}
      {children}
    </Box>
  );
};

export default EmptyState;
